import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import ColorBar from 'components/ColorBar';

import { RegistrationForm } from '../RegistrationForm';

interface Props {}

// TODO: Error messages!!!!!!!!!!!!!!!!!

const CheckoutRegister: FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <ColorBar>
      <div className="content-wrapper">
        <h1>{t('checkoutRegistration.prompt')}</h1>

        <RegistrationForm redirectURL="/checkout/payment" />
      </div>
    </ColorBar>
  );
};

export default CheckoutRegister;
